import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useStore } from '../../utils/score';



export default function Home() {

    const scoreGold = useStore(state => state.scoreZlato);
    const scoreSilicon = useStore(state => state.scoreKremik);
    
    
    

    return ( <Fragment>
        <Helmet><title>Eduraw</title></Helmet>
        <div id="home">
            
            <section className='main-results'>
               
              
                <h1>Results</h1>
                
                <div className="results-container">
                   <div className='results-gold'>
                        <h2>Gold</h2>
                        <h3>{scoreGold} points</h3>
                   </div>
                   <div className='results-silicon'>
                        <h2>Silicon</h2>
                        <h3>{scoreSilicon}points</h3>
                   </div>
                   
                </div>



                <div className="home-btn-container">
                    <Link className='home-btn' to="/">Začať Quiz</Link>
                </div>
              
               
    

                
            </section> 

            
        </div>  
        </Fragment> 
    )
       
      


}

    
